<template>
    <div class="y-scrollable-block position-relative overflow-auto">
        <table class="table table-bordered table-has-sticky table-sticky-col table-layout-fixed">
            <thead>
            <tr>
                <th>Retailer name</th>
                <th>Distributor name</th>
                <th>QTY of orders</th>
                <th>AVR last 6 mts</th>
                <th>Stock</th>
                <th>Order evolution</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="retailer in data" @click="navigateToDetails(retailer.id)">
                <th class="font-weight-normal">{{ retailer.retailer.name }}</th>
                <td>{{ retailer.retailer.parent.short_name }}</td>
                <td>{{ retailer.statistics.orders_quantity | number }}</td>
                <td>{{ retailer.statistics.avr_last6_months | number }}</td>
                <td>{{ retailer.statistics.stock | number }}</td>
                <td><number-value :n="retailer.statistics.orders_trend" percents></number-value></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
th, td {
    width: 200px;
}

tbody tr {
    cursor: pointer;
}
</style>

<script>
export default {
    props: {
        data: {
            required: true,
            type: Array,
        },
    },
    methods: {
        navigateToDetails(id) {
            // this.$router.push({ name: 'b2b.retailers.details', params: { id: id } });
        }
    }
};
</script>
